import ReactDOM from 'react-dom';
import { requireAll, setProcessingInstuctions } from './utils/root-utils';

/// Scan for all React .jsx modules
// Resolves and loads module content
const modules = requireAll(require.context('.', true, /.(j|t)sx$/));
const processingInstructions = setProcessingInstuctions(modules);

const HtmlToReactParser = require('html-to-react').Parser;

const reactParser = new HtmlToReactParser();

// Script Entry Point
window.addEventListener('load', () => {
    const e = document.getElementById('root');
    const c = reactParser.parseWithInstructions(e.outerHTML, () => true, processingInstructions);
    ReactDOM.render(c, e);
}, false);
